import { Component, Input } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'v2-dialog-bar',
    templateUrl: './v2-dialog-bar.component.html',
    styleUrls: ['./v2-dialog-bar.component.scss'],
    standalone: false
})
export class V2DialogBarComponent {
  @Input() dialogRef: DialogRef<any, any>;
  @Input() title = '';
  @Input() titleClass = 'h5 color-green-grey-1';
  @Input() topBarClass = 'bg-blue-grey-1';
  @Input() svgClass = '';
}
